export enum LanguageSymbol {
  PT_BR = "pt-BR",
  EN = "en",
  ES = "es",
}
